import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import LayoutHouseType from '../shared/layout/LayoutHouseType';
import withApiData from '../../services/withApiData';
import { performApiRequest } from '../../redux/apiData';
import ContentLoader from '../shared/ui/ContentLoader';
import ErrorBlock from '../ErrorBlock';
import { getErrorBlockProps } from '../../constants/errorMessages';
import LayoutBase from '../shared/layout/LayoutBase';
import get from 'lodash.get';
import WithSettings from '@/components/WithSettings';
var connectApiData = withApiData({
  houseType: 'getHouseType'
}, function (ownProps) {
  var _ownProps$match$param = ownProps.match.params,
    projectSlug = _ownProps$match$param.projectSlug,
    env = _ownProps$match$param.env,
    houseTypeSlug = _ownProps$match$param.houseTypeSlug;
  return {
    houseType: {
      projectSlug: projectSlug,
      env: env,
      houseTypeSlug: houseTypeSlug
    }
  };
});
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    getNewHouseType: function getNewHouseType(projectSlug, env, houseTypeSlug) {
      dispatch(performApiRequest('getHouseType', {
        projectSlug: projectSlug,
        env: env,
        houseTypeSlug: houseTypeSlug
      }));
    }
  };
};
var HouseTypeContainer = /*#__PURE__*/function (_Component) {
  function HouseTypeContainer() {
    _classCallCheck(this, HouseTypeContainer);
    return _callSuper(this, HouseTypeContainer, arguments);
  }
  _inherits(HouseTypeContainer, _Component);
  return _createClass(HouseTypeContainer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        match = _this$props.match,
        getNewHouseType = _this$props.getNewHouseType;
      var _match$params = match.params,
        projectSlug = _match$params.projectSlug,
        env = _match$params.env,
        houseTypeSlug = _match$params.houseTypeSlug;
      var _prevProps$match$para = prevProps.match.params,
        oldProjectSlug = _prevProps$match$para.projectSlug,
        oldEnv = _prevProps$match$para.env,
        oldHouseTypeSlug = _prevProps$match$para.houseTypeSlug;
      if (oldProjectSlug !== projectSlug || oldEnv !== env || oldHouseTypeSlug !== houseTypeSlug) {
        getNewHouseType(String(projectSlug), String(env), String(houseTypeSlug));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        houseType = _this$props2.houseType,
        match = _this$props2.match,
        settings = _this$props2.settings,
        renderWidth = _this$props2.renderWidth;
      var pageNotFound = get(houseType, 'request.response.status') === 404;
      var title = houseType.data && settings ? "".concat(houseType.data.variantName, " - ").concat(houseType.data.variantCodes && houseType.data.variantCodes.length ? houseType.data.variantCodes.join(', ') : '', " - ").concat(settings.siteName) : undefined;
      var meta = houseType.data ? {
        metaTitle: title
      } : {};
      var layoutSettings = {
        hasHeader: true,
        hasFooter: true,
        hasMenu: true
      };
      return __jsx(LayoutBase, {
        settings: settings,
        layoutSettings: layoutSettings,
        renderWidth: renderWidth,
        title: title,
        meta: meta,
        "data-id": "contentTypes_HouseType_LayoutBase"
      }, houseType.data && !pageNotFound && __jsx(LayoutHouseType, {
        renderWidth: renderWidth,
        data: houseType.data,
        "data-id": "contentTypes_HouseType_LayoutHouseType"
      }), houseType.request.networkStatus === 'loading' && __jsx(ContentLoader, {
        "data-id": "contentTypes_HouseType_ContentLoader"
      }), pageNotFound && __jsx(ErrorBlock, _extends({}, getErrorBlockProps(match, 'houseType', 404), {
        "data-id": "contentTypes_HouseType_ErrorBlock"
      })));
    }
  }]);
}(Component);
export default WithSettings(connectApiData(connect(null, mapDispatchToProps)(HouseTypeContainer)));